/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TChatsBulkOperationsMoveAllFromSectionToArchiveDesktopModel,
  IChatsBulkOperationsMoveAllFromSectionToArchiveDesktopRequest,
  IMappers,
  IChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponse,
  IChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponseError,
  TChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponse,
} from './types';

const defaultConfig: TChatsBulkOperationsMoveAllFromSectionToArchiveDesktopModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'chats',
  pathApi: '/v1/chats/bulk-operations/move-all-from-section-to-archive-desktop/',
  hostType: 'api',
} as TChatsBulkOperationsMoveAllFromSectionToArchiveDesktopModel;

function createChatsBulkOperationsMoveAllFromSectionToArchiveDesktopModel(
  parameters: IChatsBulkOperationsMoveAllFromSectionToArchiveDesktopRequest,
): TChatsBulkOperationsMoveAllFromSectionToArchiveDesktopModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IChatsBulkOperationsMoveAllFromSectionToArchiveDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IChatsBulkOperationsMoveAllFromSectionToArchiveDesktopRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchChatsBulkOperationsMoveAllFromSectionToArchiveDesktop<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IChatsBulkOperationsMoveAllFromSectionToArchiveDesktopOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponse
> {
  const { response, statusCode } = await httpApi.fetch(
    createChatsBulkOperationsMoveAllFromSectionToArchiveDesktopModel(parameters),
    config,
  );

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponseError);
    }
  }

  return { response, statusCode } as TChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponse;
}

export {
  defaultConfig,
  createChatsBulkOperationsMoveAllFromSectionToArchiveDesktopModel,
  fetchChatsBulkOperationsMoveAllFromSectionToArchiveDesktop,
};
